import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { C, FONTS } from '../../tokens/design';
import { useAuth } from '../../context/AuthContext';

export default function SsoCallback() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { completeSso } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    const code = params.get('ssoCode');
    const ssoError = params.get('ssoError');

    if (ssoError) {
      setError(ssoError.replaceAll('_', ' '));
      return;
    }

    if (!code) {
      setError('missing sso code');
      return;
    }

    let cancelled = false;
    completeSso(code)
      .then(() => {
        if (!cancelled) navigate('/', { replace: true });
      })
      .catch(err => {
        if (!cancelled) setError(err?.message || 'sso sign in failed');
      });

    return () => { cancelled = true; };
  }, [completeSso, navigate, params]);

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: C.bg, color: C.t1 }}>
      <div style={{ width: 'min(420px, calc(100vw - 32px))', padding: 24, border: `1px solid ${C.b1}`, borderRadius: 8, background: C.s1 }}>
        <div style={{ fontSize: 16, fontWeight: 700, fontFamily: FONTS.sans, marginBottom: 8 }}>
          {error ? 'SSO sign-in failed' : 'Completing SSO sign-in'}
        </div>
        <div style={{ fontSize: 12, color: error ? C.red : C.t2, fontFamily: FONTS.mono, lineHeight: 1.6 }}>
          {error || 'Please wait...'}
        </div>
        {error && (
          <Link to="/login" style={{ display: 'inline-block', marginTop: 16, color: C.sky, fontSize: 12, fontFamily: FONTS.mono }}>
            Back to login
          </Link>
        )}
      </div>
    </div>
  );
}
